// extracted by mini-css-extract-plugin
module.exports = {"imageSlider":"slider_imageSlider__6KYTy","imageAnchor":"slider_imageAnchor__yzRVg","image":"slider_image__nLLpI"};